import {css, StyleSheet} from "aphrodite";

import {View, type StyleType} from "@khanacademy/wonder-blocks-core";
import {PhosphorIcon} from "@khanacademy/wonder-blocks-icon";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {staticUrl} from "@khan/urls";

type Props = {
    icon: PhosphorRegular | string;
    color: string;
    style?: StyleType;
    isPNGIcon?: boolean;
};

const AIToolIcon = ({color, icon, style, isPNGIcon}: Props) => {
    return (
        <View style={[styles.container, {backgroundColor: color}, style]}>
            {isPNGIcon ? (
                <img
                    className={css(styles.container)}
                    src={staticUrl(icon)}
                    // Since the label contains the title, we hide the icon for SR
                    // and don't provide any alt text.
                    alt=""
                />
            ) : (
                <PhosphorIcon
                    size="medium"
                    role="img"
                    icon={icon}
                    style={styles.icon}
                />
            )}
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        width: 44,
        height: 44,
        justifyContent: "center",
        alignItems: "center",
        borderRadius: spacing.xSmall_8,
    },
    icon: {
        width: 30,
        height: 30,
    },
});

export default AIToolIcon;
